export const EMPTY_NOTE_CONTENT = '<p></p>'
export const EMPTY_NOTE_DEFAULT_TITLE = 'New Note'
export const EMPTY_NOTE_TITLE = ''
export const NOTE_ERROR = 'Your note failed to save!'
export const NOTE_SAVED = 'Your note was saved at'
export const NOTE_SAVING = 'Your note is saving...'
export const NOTE_TITLE_MAX_LENGTH = 80
